import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset, MergeSource } from '../../decorators';
import { EmployeeMergeData, EmployeeMergeSchema } from '../data/employee.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Resource,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder
    ]
})
export class StageResourceMergeDataset {

    @MergeSource({
        schema: EmployeeMergeSchema
    })
    resource: EmployeeMergeData;

}